<template>
    <div>
        <AppHeader title="Reports"/>
  <div v-html="reportsHtml"></div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      reportsHtml: '',
      title: 'Reports Dashboard'
    };
  },
  async created() {
    await this.fetchReports();
  },
  methods: {
    async fetchReports() {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${this.$BASE_API_URL}/api/reports`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'text/html' // Change accept header to expect HTML
          },
          responseType: 'text' // Important for HTML responses
        });

        this.reportsHtml = response.data;
        
        // Execute any scripts in the HTML
        this.$nextTick(() => {
          const scripts = this.$el.getElementsByTagName('script');
          for (let script of scripts) {
            if (script.src) {
              // Handle external scripts
              const newScript = document.createElement('script');
              newScript.src = script.src;
              document.body.appendChild(newScript);
            } else {
              // Handle inline scripts
              eval(script.innerHTML);
            }
          }
        });
        
      } catch (error) {
        console.error('Error fetching reports:', error);
        this.showError('Failed to load reports. Please try again.');
      }
    },
    showError(message) {
      if (this.$toast) {
        this.$toast.error(message);
      } else {
        alert(message);
      }
    }
  }
};
</script>
<style>
.report-card {
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    text-decoration: none;
}
</style>
